export const userAccount = {
  loginForm: {
    forgotPassword: 'Forgot your password?',
    signIn: 'Sign in',
    register: 'Register',
    dontHaveAccount: 'Don’t have an account?',
    guestCheckout: 'Checkout as Guest',
    emailAddress: {
      label: 'Email address',
      placeholder: 'Enter email address',
    },
    password: {
      label: 'Password',
      placeholder: 'Enter your password',
    },
    wrongEmailFormat: 'This is not a valid email format.',
  },
  miniLogin: {
    signIn: 'Sign in',
    register: 'Register',
    userGreeting: 'Hello, {{name}}',
    signInRegister: 'Login',
  },
  myAccountV2User: {
    signOut: 'Sign out',
  },
  accountSelection: {
    notSelectedWarnig: 'Are you sure you want to cancel your login? You will need to start the login process again.',
    notSelectedInfo: "You were logged off because you didn't select any option",
    select: 'Select',
    cancel: 'Cancel',
    confirm: 'Confirm',
    continue: 'Next',
    cancelConfirmation: 'Cancel Confirmation',
    back: 'Back',
    accountSelect: {
      title: 'Select Account',
      text: 'The account you select will affect the products and information you will see in this session.',
    },
    addressSelect: {
      title: 'Select Shipping Address',
      text: 'Please select an address for your session. Your selection may impact pricing and will be used as the default shipping address for orders at checkout.',
    },
    columns: {
      uid: 'Account #',
      name: 'Name',
      displayAddress: 'Address',
      street: 'Street',
      city: 'City',
      state: 'State',
      postalCode: 'Postal Code',
      country: 'Country',
      additionalInfo: 'Location',
      defaultWarehouseCode: 'Default Warehouse',
    },
  },
  modalRequestAccount: {
    info: 'Request access to purchase directly from Marathon Electric or expand your existing access to others.<br /> Must be an original equipment manufacturer or qualify as an authorized distributor. <br /> If you currently work for a company buying directly from Marathon Electric, contact your sales representative for your account number(s) for faster processing of your request. <br /> Please contact your Sales Representative or Account Administrator if you don’t know your Account Number.',
    form: {
      accountNumber: {
        label: 'Account Number',
      },
      reason: {
        label: 'Reason',
      },
    },
    actions: {
      cancel: 'Cancel',
      submit: 'Request Account',
    },
  },
};
